var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plan_detail"},[_c('img',{attrs:{"src":_vm.details[_vm.key],"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }